import { twMerge } from "tailwind-merge";
import infoIcon from "../../assets/icons/info-outline.svg";
import useTestId from "../../hooks/useTestId";
import { ROUTES } from "../../routes/config";
import Link from "../Link";

type Props = {
    isFixed?: boolean;
    label?: string;
    href?: string;
    backButtonSettings?: {
        label?: string;
        href: string;
    };
};

export default function BottomBackToMain({
    isFixed,
    label,
    href,
    backButtonSettings,
}: Props) {
    const testId = useTestId();
    const _href = href || `/test/${testId}/${ROUTES.INTERPRETATION.path}`;
    const _label = label || "Back to Interpretation";

    const buttonWidthClass = backButtonSettings ? 'w-[160px]' : 'w-[366px]';

    return (
        <div
            className={twMerge(
                "flex justify-between w-full items-center",
                isFixed && "isBottomPanel"
            )}
        >
            <div
                className="flex items-center gap-1.5 xl:ps-6"
                style={{ marginInlineStart: "var(--left-sidebar-width)" }}
            >
                <img src={infoIcon} alt="info icon" className="w-5 h-5" />
                <span className="text-black font-semibold text-base xl:text-xl leading-9">
                    Final interpretation must be confirmed
                </span>
            </div>
            <div className="flex items-center gap-2 xl:gap-4">
                {backButtonSettings ? (
                    <Link
                        to={backButtonSettings.href}
                        className={`btn-outline-primary ${buttonWidthClass}`}
                    >
                        {backButtonSettings.label || "Back"}
                    </Link>
                ) : null}
                <Link to={_href} className={`btn-primary ${buttonWidthClass}`}>
                    {_label}
                </Link>
            </div>
        </div>
    );
}
